import { Form, FormSaveButton } from '@ztechapps/webui.form'
import type { AdjustmentAddComponent } from '@ztechapps/adjustment.webui'
import { useAdjustmentAddContext } from '@ztechapps/adjustment.webui'
import { AdjustmentAddProvider } from '@ztechapps/adjustment.webui'
import React from 'react'
import type { SaveCancelButtonsProps } from '@ztechapps/webui.button'
import { Stack } from 'react-bootstrap'
import { HorizontalStack } from '@ztechapps/webui.util'

const AdjustmentFormSave = (_props: SaveCancelButtonsProps) => <FormSaveButton text="Create" />
const components = {
  saveCancelButtons: AdjustmentFormSave,
} as AdjustmentAddComponent
export const AddAdjustment = ({ onCloseMenu }: { onCloseMenu: () => void }) => {
  return (
    <AdjustmentAddProvider components={components}>
      <Layout onCloseMenu={onCloseMenu} />
    </AdjustmentAddProvider>
  )
}

export const Layout = ({ onCloseMenu }: { onCloseMenu: () => void }) => {
  const { initialValues, validate, onSubmit, onReset, components } = useAdjustmentAddContext()

  const onSubmitCore = async (args) => {
    await onSubmit(args)
    onCloseMenu()
  }

  return (
    <Form initialValues={initialValues} validate={validate} onSubmit={onSubmitCore} onReset={onReset}>
      <Stack gap={2}>
        <components.formInput />
        <HorizontalStack className="justify-content-end">
          <div>
            <components.saveCancelButtons />
          </div>
        </HorizontalStack>
      </Stack>
    </Form>
  )
}
